import "./locationPhysicianDetailsViewComponent.scss";
import React, {useEffect, useState} from "react";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import {Edit} from "@mui/icons-material";
import AccordionComponent from "../../../../../shared/components/accordion/accordionComponent";
import {CommonService} from "../../../../../shared/services";
import PhysicianDetailsComponent from "../../../../../shared/components/physician-details/PhysicianDetailsComponent";

interface LocationPhysicianDetailsViewComponentProps {
    physicianList?: any;
    onEditModeOpen?: Function;
    canEdit?: boolean;
}

const LocationPhysicianDetailsViewComponent = (props: LocationPhysicianDetailsViewComponentProps) => {
    const {physicianList, onEditModeOpen,canEdit} = props;

    const [physicianDetailsList, setPhysicianDetailsList] = useState<any[]>([]);

    useEffect(() => {
        if (physicianList?.length > 0) {
            setPhysicianDetailsList(physicianList)
        }
    }, [physicianList]);

    return (
        <div className={'location-physician-details-view-component'}>
            <div
                className={'d-flex justify-content-space-between align-items-center mrg-bottom-10'}>
                <div className="form-sub-title mrg-top-15">All Location Providers/Physicians</div>
                {
                    canEdit &&
                    <ButtonComponent
                        variant={"outlined"}
                        fullWidth={false}
                        type={'button'}
                        color={"primary"}
                        handleClick={onEditModeOpen}
                        startIcon={<Edit/>}
                    >
                        Edit Details
                    </ButtonComponent>
                }
            </div>
            {
                physicianDetailsList?.length === 0 &&
                <div className={'no-physician-found'}>No Provider/Physician have been added to this location.</div>
            }
            {physicianDetailsList?.map((physician: any, index: any) => {
                return (
                    <div key={index} className="accordion-layout mrg-bottom-20">
                        <AccordionComponent
                            // disabled={!values.physicianId}
                            isExpanded={physicianDetailsList[index]?.isPhysicianExpand}
                            title={CommonService.physicianWithPrefix(physician)}
                            subTitle={`(NPI: ${physician.npiNumber})`}
                            onChange={(isExpanded) => {
                                if (isExpanded) {
                                    // setCurrentPhysicianIndex(index);
                                }
                                // setFieldValue(`physicianDetails[${index}].isPhysicianExpand`, isExpanded);
                            }}
                        >
                            <div className="physician-details-section">
                                <div className="form-sub-title mrg-top-20">
                                    Personal Details
                                </div>
                                <PhysicianDetailsComponent physician={physician}/>
                            </div>
                        </AccordionComponent>
                    </div>
                )
            })
            }
        </div>
    );

};

export default LocationPhysicianDetailsViewComponent;
